<script>
export default {
  name: 'BettingPromotionsTermsModal',
  props: {
    termsText: {
      type: String,
      default: '',
    },
  },
  methods: {
    toggleTCsModal(isActive, text) {
      this.$store.dispatch('BettingPromotions/toggleModalStatus', { isActive, text });
    },
  },
};
</script>

<template>
  <div class="betting-promos-terms-modal">
    <div class="betting-promos-terms-modal__header">
      <h3 class="betting-promos-terms-modal__header-text">Terms & Conditions</h3>
      <div class="betting-promos-terms-modal__close" @click.prevent="toggleTCsModal(false, '')">
        <a href="/">&times;</a>
      </div>
    </div>
    <div class="betting-promos-terms-modal__details">
      <div>{{ termsText }}</div>
    </div>
  </div>
</template>
